import { FC } from "react";

import { Typography } from "@mui/material";
import { PickersCalendarHeaderProps } from "@mui/x-date-pickers-pro";
import { getLanguage } from "src/utils/Languages/LanguageContext";

const CustomCalendarHeader: FC<PickersCalendarHeaderProps> = ({
  currentMonth,
}) => {
  const language = getLanguage();

  return (
    <Typography
      variant="subtitle1"
      color="textSecondary"
      sx={{ textAlign: "center", mb: "1rem" }}
    >
      {currentMonth.toLocaleString(language, { month: "long" })}
    </Typography>
  );
};

export default CustomCalendarHeader;
